import { create } from 'zustand'

/**
 * Task-ul foarte asemanator gasit de server la creare sau atribuire (27.10.2026). Fereastra lui e
 * una singura, montata in `App`; o deschide orice refuz „dublura”, de oriunde a venit.
 */
export interface Dublura {
  id: number
  vizibil: boolean
  titlu: string | null
  departament: string | null
  departamentNume: string | null
  stare: string | null
  oameni: string[]
  creat: string
}

interface StareDublura {
  dublura: Dublura | null
  mesaj: string
  /** Ce voia omul sa scrie: la un task nevazut, se adauga ca informatie pe el. */
  text: string
  arata: (d: Dublura, mesaj: string, text: string) => void
  inchide: () => void
}

export const useDubluraStore = create<StareDublura>((set) => ({
  dublura: null,
  mesaj: '',
  text: '',
  arata: (dublura, mesaj, text) => set({ dublura, mesaj, text }),
  inchide: () => set({ dublura: null, mesaj: '', text: '' }),
}))

/**
 * Daca eroarea e un refuz „dublura”, deschide fereastra si spune `true` — apelantul nu mai arata
 * alt mesaj. `text`: titlul si detaliile pe care omul voia sa le puna.
 */
export function arataDublura(e: unknown, text = ''): boolean {
  const r = (
    e as {
      response?: { status?: number; data?: { dublura?: Dublura; error?: { message?: string } } }
    }
  )?.response
  if (r?.status !== 409 || !r.data?.dublura) return false
  useDubluraStore.getState().arata(r.data.dublura, r.data.error?.message ?? '', text)
  return true
}
